import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  ref: "modalRef",
  class: "modal-content neon"
}
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "segments" }
const _hoisted_5 = { class: "footer" }
const _hoisted_6 = { class: "footer-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_modal_header = _resolveComponent("app-modal-header")!
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_button = _resolveComponent("app-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_modal_header, {
      title: _ctx.getTitle,
      onClose: _ctx.close
    }, null, 8, ["title", "onClose"]),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.card.segments, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item,
              class: "segment",
              style: _normalizeStyle({ backgroundColor: item.color })
            }, null, 4))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_app_input, {
          modelValue: _ctx.signIn,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.signIn) = $event)),
          icon: ['fas', 'fa-pencil'],
          "is-label": false
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", {
          class: "btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveTemplate && _ctx.saveTemplate(...args)))
        }, [
          _createVNode(_component_app_button, {
            loading: _ctx.isLoading,
            severity: "warning",
            title: _ctx.id ? 'update' : 'save'
          }, null, 8, ["loading", "title"])
        ])
      ])
    ])
  ], 512))
}